__turbopack_context__.v({
  "cardLink": "EnhancedArticleCard-module__pJKXYa__cardLink",
  "readMore": "EnhancedArticleCard-module__pJKXYa__readMore",
});
